import React, { forwardRef } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 100vh;
  width: 100vw;

  & > aside {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 400px;
    max-height: 100%;
    z-index: 10;
  }

  & > main {
    position: absolute;
    inset: 0;
  }
`;

export type LayoutProps = React.HtmlHTMLAttributes<HTMLDivElement> & {
  sidebar?: React.ReactNode;
  children?: React.ReactNode;
};

export const Layout = forwardRef<HTMLDivElement, LayoutProps>(
  ({ sidebar, children, ...restProps }, ref) => {
    return (
      <Container ref={ref} {...restProps}>
        <aside>{sidebar}</aside>
        <main>{children}</main>
      </Container>
    );
  },
);
